import templateUrl from './dashboard.html';

export const dashboardComponent = {
    templateUrl,

    bindings: {
    	list: '<'
    },

    controller: class DashboardComponent {
    	$onInit() {
    		this.isSidebarOpen = false;
    	}
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.js